import { useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';

export const USE_CLIENT_GET_STRIPE_CHECKOUT_SESSION = 'useClientGetStripeCheckoutSession';

/**
 * Query the Stripe checkout session endpoint to get the NEW_TOKEN after payment
 * Backend returns just the token as a string, not the full response
 */
export const useClientGetStripeCheckoutSession = ({
	sessionId,
	refetchOnWindowFocus = false,
	token,
}: {
	sessionId: string | null;
	refetchOnWindowFocus: boolean;
	token: string;
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled: Boolean(sessionId),
		queryFn: () => {
			// Backend returns just the NEW_TOKEN as a string
			return apiClient.get<string>(`stripe/auth/checkout-session/${sessionId}?token=${encodeURIComponent(token)}`);
		},
		queryKey: [USE_CLIENT_GET_STRIPE_CHECKOUT_SESSION, sessionId],
		refetchOnWindowFocus,
	});
};
